import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import gazetteer, { CountryCodes, type Market } from '@bridebook/toolbox/src/gazetteer';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { getPricingCategoryByIndicator } from '@bridebook/web/app-shared/lib/supplier/utils';
import { getPricingValueString } from '@bridebook/web/lib/supplier/utils';
import { arePropsEqual } from '@bridebook/web/lib/utils';
import { BudgetSpriteIcon, HotelSpriteIcon, UserDoubleSpriteIcon } from './search-svg-sprite';

interface IProps {
  market: Market;
  supplier: IUISupplier;
}

const PropertiesComponent = ({ market, supplier }: IProps) => {
  const { t } = useTranslation('supplierCard');
  const { accommodationRooms: bedrooms, capacityDining: seats, countryCode } = supplier;
  const currency = gazetteer.getMarketByCountry(countryCode ?? CountryCodes.GB).currency;
  const hasSeats = !!(seats && seats > 0);
  const hasBedrooms = !!(bedrooms && bedrooms > 0);
  const pricingCategory = getPricingCategoryByIndicator(supplier.pricingIndicator);

  return (
    <ul>
      {hasSeats && (
        <li>
          <UserDoubleSpriteIcon width={16} height={16} />
          {seats}
        </li>
      )}
      {hasBedrooms && (
        <li>
          <HotelSpriteIcon width={16} height={16} />
          {bedrooms}&nbsp;
          <span>
            {t('infoCard.bedrooms.nonZero', {
              count: bedrooms,
            })}
          </span>
        </li>
      )}
      <li>
        <BudgetSpriteIcon width={16} height={16} />
        {getPricingValueString(currency, market, supplier, pricingCategory, true)}
      </li>
    </ul>
  );
};

export const Properties = memo(PropertiesComponent, arePropsEqual);
